import * as React from "react";
import {
  Map,
  Source,
  Layer,
  NavigationControl,
  FullscreenControl,
  ScaleControl,
  GeolocateControl,
  Marker,
} from "!react-map-gl";
import { useState, useEffect, useMemo } from "react";
import mapboxgl from "mapbox-gl";
import { LoadingOutlined } from "@ant-design/icons";
// import map.css
import "./map.css";
import { LocationMarkerIcon } from "@heroicons/react/solid";
import "mapbox-gl/dist/mapbox-gl.css";
import { getJSONData } from "../utils";

mapboxgl.workerClass =
  require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;
const MapSummary = () => {
  const [data, setData] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [cities, setCities] = useState([]);
  // const [countries, setCountries] = useState([]);

  useEffect(() => {
    asyncFetch();
  }, []);

  const asyncFetch = () => {
    fetch(`${process.env.GATSBY_PATH_PREFIX}/data/all.geojson`)
      .then((response) => response.json())
      .then((json) => {
        setData(json);
        setDataLoaded(true);
      })
      .catch((error) => {
        console.log("fetch data failed", error);
      });

    const getCities = getJSONData(
      `${process.env.GATSBY_PATH_PREFIX}/data/topcities.json`
    );
    getCities.then((data) => {
      // console.log(data);
      setCities(data);
    });

    // const getCountries = getJSONData(
    //   `${process.env.GATSBY_PATH_PREFIX}/data/top.geojson`
    // );
    // getCountries.then((data) => {
    //   // console.log(data);
    //   setCountries(data);
    // });
  };

  const MAX_ZOOM_LEVEL = 9;
  const heatmapLayer = {
    id: "heatmap",
    maxzoom: MAX_ZOOM_LEVEL,
    type: "heatmap",
    paint: {
      "heatmap-weight": {
        property: "freq",
        type: "exponential",
        stops: [
          [0, 0],
          [5, 1.5],
        ],
      },

      // Increase the heatmap color weight weight by zoom level
      // heatmap-intensity is a multiplier on top of heatmap-weight
      "heatmap-intensity": [
        "interpolate",
        ["linear"],
        ["zoom"],
        0,
        1,
        MAX_ZOOM_LEVEL,
        3,
      ],
      // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
      // Begin color ramp at 0-stop with a 0-transparancy color
      // to create a blur-like effect.
      "heatmap-color": [
        "interpolate",
        ["linear"],
        ["heatmap-density"],
        0,
        "rgba(33,102,172,0)",
        0.2,
        "rgb(103,169,207)",
        0.4,
        "rgb(209,229,240)",
        0.6,
        "rgb(253,219,199)",
        0.8,
        "rgb(239,138,98)",
        0.9,
        "rgb(255,201,101)",
      ],
      // Adjust the heatmap radius by zoom level
      "heatmap-radius": [
        "interpolate",
        ["linear"],
        ["zoom"],
        0,
        1,
        MAX_ZOOM_LEVEL,
        15,
      ],
      // Transition from heatmap to circle layer by zoom level
      "heatmap-opacity": ["interpolate", ["linear"], ["zoom"], 7, 1, 9, 0],
    },
  };

  const countriesLayer = {
    id: "countries",
    type: "fill",
    // source: "countries",

    paint: {
      "fill-outline-color": "#fff",
      "fill-color": "#059669",
      // {
      // property: "op",
      // type: "exponential",
      // stops: [
      //   [0, "rgba(33,102,172)"],
      //   [0.2, "rgb(103,169,207)"],
      //   [0.4, "rgb(209,229,240)"],
      //   [0.6, "rgb(253,219,199)"],
      //   [0.8, "rgb(239,138,98)"],
      //   [0.9, "rgb(255,201,101)"],
      // ],

      // },
      "fill-opacity": 0.2,
    },
  };

  const mapRef = React.useRef();

  const onMouseMove = (e) => {
    mapRef.current.getCanvas().style.cursor = "pointer";

    document.getElementById("tweetlocation").innerHTML =
      e.features[0].properties.name;
    document.getElementById("tweetcount").innerHTML =
      e.features[0].properties.freq;

    const containerWidth = document.getElementById("mapdiv").clientWidth;
    const containerHeight = document.getElementById("mapdiv").clientHeight;
    const tooltip = document.getElementById("tooltipmap");

    tooltip.style.left =
      e.point.x + tooltip.clientWidth + 10 > containerWidth
        ? e.point.x - tooltip.clientWidth + "px"
        : e.point.x + "px";
    tooltip.style.top =
      e.point.y + tooltip.clientHeight + 10 > containerHeight
        ? e.point.y - tooltip.clientHeight + "px"
        : e.point.y + "px";
    tooltip.style.display = "block";
  };

  const onMouseLeave = (e) => {
    const tooltip = document.getElementById("tooltipmap");
    //hide tooltip
    tooltip.style.display = "none";
    mapRef.current.getCanvas().style.cursor = "";
  };

  const onMapLoad = React.useCallback(() => {
    mapRef.current.on("move", () => {
      // console.log("move", mapRef.current.getZoom());
    });

    mapRef.current.on("click", (e) => {
      // console.log(`A click event has occurred at ${e.lngLat}`);
    });

    mapRef.current.on("mousemove", "countries", onMouseMove);
    mapRef.current.on("mouseleave", "countries", onMouseLeave);
  }, []);

  const Pin = React.memo(({ city }) => {
    return (
      <div className="pointer-events-nonep  ">
        <span
          id={city.name}
          className="bg-white p-1 px-2 pointer-events-none  hidden rounded bg-opacity-90 "
        >
          <span className="font-semibold block"> Top Cities </span>
          {city.name}
        </span>
        <LocationMarkerIcon
          // onClick={(e) => {}}
          onMouseMove={(e) => {
            document.getElementById(city.name).style.display = "block";

            document.getElementById("tooltipmap").style.opacity = "none";
          }}
          onMouseLeave={(e) => {
            document.getElementById(city.name).style.display = "none";
          }}
          className="text-red-500 flex items-center mx-auto h-6 hover:cursor-pointer  "
        />
      </div>
    );
  });
  const pins = useMemo(() => {
    // console.log("computing pins", cities.length);
    return cities.map((city, index) => (
      <Marker
        key={`marker-${index}`}
        longitude={city.longitude}
        latitude={city.latitude}
        anchor="bottom"
      >
        <Pin city={city} />
      </Marker>
    ));
  }, [cities]);

  return (
    <div className="rounded border-t-2 border-indigo-500 relative">
      <div id="mapdiv" className="">
        <Map
          initialViewState={{
            // longitude: 8.226691258248366,
            // latitude: 8.539903063779846,
            longitude: -11.70965021434057,
            latitude: 22.75446388201803,
            zoom: 1.414,
          }}
          ref={mapRef}
          onLoad={onMapLoad}
          attributionControl={false}
          className="rounded"
          style={{ width: "100%", height: 500, borderRadius: "4px" }}
          mapStyle="mapbox://styles/mapbox/dark-v10"
          mapboxAccessToken={process.env.GATSBY_MAPBOX_TOKEN}
        >
          <GeolocateControl position="top-left" />
          <FullscreenControl position="top-left" />
          <NavigationControl position="top-left" />
          <ScaleControl />
          {pins}
          {data && (
            <Source type="geojson" data={data}>
              <Layer {...heatmapLayer} />
            </Source>
          )}
          {/* {countries && (
            <Source type="geojson" data={countries}>
              <Layer {...countriesLayer} />
            </Source>
          )} */}
        </Map>
      </div>
      {!dataLoaded && (
        <div className=" absolute top-0  p-2 rounded w-full">
          <div className=" bg-indigo-50 p-2 rounded  bg-opacity-90 ">
            {" "}
            <LoadingOutlined />{" "}
            <span className="ml-2"> loading map data...</span>
          </div>
        </div>
      )}

      <div className=" absolute top-0 right-0  p-2 rounded inline-block">
        <div className=" bg-indigo-50 p-2 rounded  bg-opacity-90 ">
          {" "}
          <LocationMarkerIcon className="text-red-500  h-6  inline-block " />
          <span className="mx-2 text-sm inline-block">
            {" "}
            Top 20 Cities by # tweets{" "}
          </span>
        </div>
      </div>

      <div
        id="tooltipmap"
        className="pointer-events-none absolute top-0 ripght-0  p-2 rounded hidden"
      >
        <div className=" bg-indigo-50 p-2 rounded  bg-opacity-90 ">
          {" "}
          <LocationMarkerIcon className="h-5 inline-block" />{" "}
          <span id="tweetlocation" className="font-semibold">
            {" "}
            Nigeria{" "}
          </span>
          <div className="mt-2">
            <span
              id="tweetcount"
              className="p-1 px-2 mr-2  bg-indigo-700 rounded text-white"
            >
              12000
            </span>
            tweets
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapSummary;
